<div class="dropdown-wrapper">
    <ham-button
        #userFilterButtonWrapper
        class="user-filter-button"
        size="lg"
        [variant]="filterIsActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(userFilterButtonWrapper)"
    >
        <span class="filter-number" *ngIf="filterIsActive"> {{ selectedUserIds?.length }} </span>
        {{ label | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-scroll-wrapper">
        <div class="flyout-user-options-content">
            <ham-filter
                class="search-bar-users"
                [placeholder]="'aumico_projects_overview_search_projects' | i18next"
                [hasFilterButton]="false"
                (filter)="onSearchFilterChange($event)"
            ></ham-filter>
            <div *ngFor="let user of users; let i = index">
                <label class="custom-checkbox user-option">
                    <input
                        type="checkbox"
                        [checked]="selectedUserIds?.includes(user.id)"
                        (change)="onUserSelection(user.id, $event.target.checked)"
                    />

                    <label class="assignee" (click)="$event.stopPropagation(); toggleUserSelection(user.id)">
                        <span class="avatar" *ngIf="showAvatar">{{ getInitials(user.name) }}</span>
                        <span
                            class="name"
                            >{{ user.name }}</span
                        >
                    </label>
                </label>

                <!-- Separator after first item (the own user); not for tags, they have no avatar -->
                <div *ngIf="i === 0 && showAvatar" class="user-separator"></div>
            </div>
        </div>
    </div>
    <div class="filter-actions">
        <ham-button variant="teal" size="sm" (click)="applyFilter()">{{
            'aumico_pm_tasks_apply_filter' | i18next
        }}</ham-button>
        <ham-button variant="white" size="sm" (click)="clearFilter()">{{
            'aumico_pm_tasks_clear_filter' | i18next
        }}</ham-button>
    </div>
</span>
